const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAydjFoOFYyaDJ2MWgyYTIgMiAwIDAgMSAyIDJ2MTVhMiAyIDAgMCAxLTIgMkg0YTIgMiAwIDAgMS0yLTJWNWEyIDIgMCAwIDEgMi0yaDJWMmgyem0xMiA4SDR2MTBoMTZWMTB6TTkgMTZ2Mkg3di0yaDJ6bTQgMHYyaC0ydi0yaDJ6bS00LTR2Mkg3di0yaDJ6bTQgMHYyaC0ydi0yaDJ6bTQgMHYyaC0ydi0yaDJ6TTYgNUg0djNoMTZWNWgtMnYxaC0yVjVIOHYxSDZWNXoiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  M as default
};
//# sourceMappingURL=date-7525115c.mjs.map
